/** @module qt.route player相关
 *  @description 节目播放相关路由
 */
import { inApp } from '../env';
import { invokeSchema } from '../base';

/**
 * 跳转主播详情页
 * @version: 支持H5
 * @example
 * ```
 * qt.route.jumpToPodcasterDetail({
  podcasterId: '6868b69afc345d57b115678ef6a15c70'
})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */
export function jumpToPodcasterDetail({
  podcasterId,
  awakeApp,
}: {
  /** 主播的 userId */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  podcasterId: string;
  /** 站外直接唤醒APP而不是跳转 */
  awakeApp?: boolean;
}): Promise<unknown> {
  if (inApp || awakeApp) {
    return invokeSchema(`qingtingfm://app.qingting.fm/podcasters`, { podcasterId });
  }
  window.location.href = `https://m.qingting.fm/podcasters/${podcasterId}`;
  return Promise.resolve();
}

/**
 * 跳转专辑页/付费落地页，
 * @version: 支持H5
 * @example
 * ```
 * qt.route.jumpToChannel({channelId: '92420'})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */
export function jumpToChannel({
  channelId,
  awakeApp,
}: {
  /** 专辑ID */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  channelId: string;
  /** 站外直接唤醒APP而不是跳转 */
  awakeApp?: boolean;
}): Promise<unknown> {
  if (inApp || awakeApp) {
    console.log('invoked jumpToChannel');
    return invokeSchema(`qingtingfm://app.qingting.fm/vchannels/${channelId}`);
  }
  window.open(`https://m.qingting.fm/vchannels/${channelId}`);
  return Promise.resolve();
}

/**
 * 跳转节目页 
 * @version: 支持H5
 * @example
 * ```
 * qt.route.jumpToProgram({channelId: '92420', programId: '12367099'})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */
export function jumpToProgram({
  programId,
  channelId,
  type = 'ondemand',
  redirect,
  awakeApp = false,
}: {
  /** 专业ID */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  channelId: string;
  /** 节目ID */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  programId: string;
  type?: string;
  redirect?: string;
  /** 站外直接唤醒APP而不是跳转 */
  awakeApp?: boolean;
}): Promise<unknown> {
  if (inApp || awakeApp) {
    return invokeSchema('qingtingfm://app.qingting.fm/playingview', {
      channel_id: channelId,
      program_id: programId,
      type,
      redirect,
    });
  }
  window.open(`https://m.qingting.fm/vchannels/${channelId}/programs/${programId}`);
  return Promise.resolve();
}

/**
 * 跳转直播间
 * @example
 * ```
 * qt.route.jumpToLive({uid:'6f9c4eb9a76fcfbb1434628fcf415e5f'})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });

 * ```
 */
export function jumpToLive({
  uid,
}: {
  /** 直播间 id */
  uid: string;
}): Promise<unknown> {
  return invokeSchema('qingtingfm://app.qingting.fm/live/room', {
    uid,
  });
}

/**
 * 跳转clubhouse
 * @example
 * ```
 * qt.route.jumpToClubhouse({roomId:'100001261'})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */
export function jumpToClubhouse({
  roomId,
}: {
  /** 房间 id */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  roomId: string;
}): Promise<unknown> {
  // qingtingfm://app.qingting.fm/clubhouse?roomId=${roomId}
  return invokeSchema('qingtingfm://app.qingting.fm/clubhouse', {
    roomId,
  });
}

/** @ignore */
export const play = {
  jumpToPodcasterDetail,
  jumpToChannel,
  jumpToProgram,
  jumpToLive,
  jumpToClubhouse,
};
